'use strict'
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./redux-toolkit.production.min.cjs')
} else {
  module.exports = require('./redux-toolkit.development.cjs')
}